import { Stack } from '@mui/system';
import { memo } from 'react';
import { TrafficRuleProperties } from './trafficRules';
import { LogicalSpaceDimensions } from './LogicalSpaceDimensions';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { Divider } from '@mui/material';

function LogicalSpaceParametersComponent() {
  const selectedIds = useAppStore((state) => state.selectedIds);

  const selectedLogicalSpace = useFloorplanDesignStore((state) => {
    if (selectedIds.length !== 1) return undefined;
    return state.getLogicalSpacesByIds(selectedIds)[0];
  });

  if (!selectedLogicalSpace) {
    return null;
  }

  return (
    <Stack spacing={1} divider={<Divider />}>
      <LogicalSpaceDimensions logicalSpace={selectedLogicalSpace} />
      <TrafficRuleProperties logicalSpace={selectedLogicalSpace} />
    </Stack>
  );
}

export const LogicalSpaceParameters = memo(LogicalSpaceParametersComponent);
